// extracted by mini-css-extract-plugin
export default {"root":"SiteList-module__root","list":"SiteList-module__list"};